<!-- SubscriptionModal.vue -->
<template>
  <ModalView
    :isVisible="isModalVisible"
    :title="'Choose your collection method'"
    @close="closeModal"
  >
    <div :class="['Fingerprick-grid', gridClass]">
      <div  v-for="method in availableCollectionMethods"
      :key="method.name" class="fine-chiled-grid d-flex flex-column ">
        <div> 
          <img :src="Array.isArray(method.icon) ? method.icon[0]?.url : method.icon || 'default-icon.png'" 
          alt=""  class="method-img" />
          <h4>{{ method.name }}</h4>
          <!-- <h5>Free</h5> -->
        </div>
        <hr />
        <p v-html="method.description" />
        <button class="btn btn-outline-primary btn-sm px-5 py-2" @click="setCollectionMethod(method._id)">Select</button>
      </div>
    </div>
  </ModalView>
</template>

<script>
import ModalView from "@/components/Modal/ModalView.vue";

export default {
  name: "SubscriptionModal",
  components: {
    ModalView,
  },
  props: ["isModalVisible","product"],
  
  methods: {
    closeModal() {
      this.$emit("close"); // Emit the close event to the parent component
    },
    setCollectionMethod(methodId) {
      this.$emit("collectionMethod", methodId);
      // Keep backward compatibility with existing BloodDetails flow.
      this.$emit("openOrderModal", this.product.product_type);
      // Current HealthStore flow.
      this.$emit("openSubscriptionModal", this.product.product_type);
      this.$emit("close");
    },
  },

  computed: {
    availableCollectionMethods() {
      if (!this.product || !this.product.collection_methods) {
        return [];
      }
      return this.product.collection_methods.filter(
        (method) =>
          !(
            process.env.VUE_APP_AUTH_PROVIDER === "clerk" &&
            method._slug === "digitalcollection"
          )
      );
    },  
    gridClass() {
      const methodCount = this.availableCollectionMethods.length;
      if (methodCount === 1) {
        return 'grid-one-column';
      } else if (methodCount === 2) {
        return 'grid-two-columns';
      }
      return 'grid-default';
    }
  },
};
</script>
